import 'reflect-metadata';
import { createRoot } from 'react-dom/client';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { registry } from '@betgames/bg-state-manager';
import { ErrorBoundary } from '@bg-components/ErrorBoundary';
import { ErrorPage } from '@bg-components/Pages/Error';
import { ROOT_CLASS, envConfig, isBlacklisted, routeUrlGenerator } from '@bg-shared';
import { Auth, Integration } from './routes/Auth';
import { Root } from './routes/Root';
import './polyfills';
import 'styles/main.scss';

registry.configureDevtools({
    enabled: envConfig.isDevEnv || envConfig.isStagingEnv,
});

if (window.location.hash) {
    // TODO: need to track partners who still uses hash
    // also update betgames.js and remove #
    const pathWithoutHash = window.location.hash.replace('#', '');
    window.history.replaceState(null, null, pathWithoutHash);
    window.location.reload();
} else if (!isBlacklisted()) {
    const container = document.querySelector(`.${ROOT_CLASS}`);
    const root = createRoot(container);

    root.render(
        <BrowserRouter>
            <ErrorBoundary ErrorComponent={ErrorPage}>
                <Routes>
                    <Route path={`${routeUrlGenerator.routes.AUTH}/*`} element={<Auth />} />
                    <Route
                        path={`${routeUrlGenerator.routes.INTEGRATION}/*`}
                        element={<Integration />}
                    />
                    <Route path="/*" element={<Root />} />
                </Routes>
            </ErrorBoundary>
        </BrowserRouter>,
    );
}
